import React, { useEffect } from 'react';
import bem from 'utils/bem';
import { useFormikContext } from 'formik';
import Text from 'components/Text';
import { Button } from 'components/Button';
import UserAgreementCheckboxField from 'forms/fields/UserAgreementCheckboxField';
import PaymentField from 'forms/fields/PaymentField';
import PaymentBalanceField from 'forms/fields/PaymentBalanceField';
import Summary from './Summary';
import './index.sass'
import KZNotEnoughBalance from 'components/KZNotEnoughBalance';
import Model from '../../../../model';
import { ForeignCardWidget } from 'components/ForeignCardWidget';

const { block, el } = bem('office-pay-purchase-form');

export default ({ price, title, address, isDigital, ...form }) => {

    const { setFieldValue } = useFormikContext();

    useEffect(() => {
        setFieldValue('price', price);
    }, [ price ])

    const { kzNotEnoughBalance, isKZ } = Model.kz;

    return <form className={ block() } onSubmit={ form.handleSubmit }>
        <div className={ el('title') }>
            <Text serif>{title}</Text>
        </div>
        <div className={ el('fields') }>
            { !isKZ && <div className={ el('payment') }>
                <div className={ el('payment-title') }>
                    <Text>Способы оплаты</Text>
                </div>
                <PaymentField/>
            </div> }
            { !isDigital && <div className={ el('payment-balance') }>
                <PaymentBalanceField className={ el('balance') } price={ price } mod={ 'long' }/>
            </div> }
            <KZNotEnoughBalance price={price} />
            { window.isRuDomain && <ForeignCardWidget /> }
            { address && <div className={ el('delivery-address')}>
                <div className={el('delivery-address-label')}>
                    <Text>Адрес доставки</Text>
                </div>
                <div className={el('delivery-address-label')}>
                     <Text>{address}</Text>
                </div>
            </div> }
            <div className={ el('summary') }>
                <Summary price={ price }/>
            </div>
            <div className={ el('footer') }>
                <UserAgreementCheckboxField name='acceptConditions'/>
                <Button
                    type={ 'submit' }
                    mod='gold'
                    disabled={ form.isSubmitting || kzNotEnoughBalance(price) }>
                    Оплатить
                </Button>
            </div>
        </div>
    </form>
}
